import React, { Component } from 'react';

import { array, bool } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames } from '@philips-emr/tws-utils';

import { ReactComponent as ExclamationMark } from '../../../resources/assets/components/DLS_ExclamationMark_Circle.svg';
import { ReactComponent as RoundCheckmark } from '../../../resources/assets/components/DLS_RoundCheckmark.svg';

import './validation-list.css';

class ValidationList extends Component {
  static propTypes = {
    collapsed: bool,
    data: array,
    value: array,
  };

  static defaultProps = {
    collapsed: false,
    data: [],
  };

  renderValidation(validation) {
    const { name, valid, message } = validation;

    if (!message) return null;

    const vClassName = classNames({
      'c-validation-list__item': true,
      'is-invalid': !valid,
      'is-valid': valid,
    });

    const Icon = valid ? RoundCheckmark : ExclamationMark;

    return (
      <li className={vClassName} key={name}>
        <Icon className="c-validation-list__icon"/>
        {msg(message)}
      </li>
    );
  }

  render() {
    const { data, collapsed } = this.props;

    if (!data.length) return null;

    const className = classNames({
      'c-validation-list': true,
      'is-collapsed': collapsed,
    });

    return (
      <ul className={className}>
        {data.map(this.renderValidation)}
      </ul>
    );
  }
}

export default ValidationList;
